import Links from "./Links";

function get_drawer_links(type) {
    let arr = [];
    let url = process.env.VUE_APP_BASE_URL + '/api/get-permissions-for-user';

    axios.post(url, { roleName: type })
        .then((res) => {
            let result1 = Links;
            let result2 = res.data;

            var result = result1.filter(function (o1) {
                return result2.some(function (o2) {
                    if (o2.module_path && o2.module_is_show === 1) {
                        return o1.to.name === o2.module_path;
                    }
                });
            });

            result.map(item => {
                arr.push(item)
            })
        })

    return arr;

    if (type === "Admin") {
        return AdminLinks
    } else if (type === "Student") {
        return StudentLinks
    } else if (type === "Tutor") {
        return TutorLinks
    }

}

const AdminLinks = [
    {
        flag: 'admin',
        icon: "mdi-poll-box",
        text: "Dashboard",
        exact: true,
        to: {
            name: "APDashBoard"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-school",
        text: "Students",
        exact: false,
        to: {
            name: "APStudents"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-teach",
        text: "Tutors",
        exact: false,
        to: {
            name: "Tutors"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-teach",
        text: "Sessions",
        exact: false,
        to: {
            name: "TutorSessions"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-teach",
        text: "Attendance",
        exact: false,
        to: {
            name: "Attendance"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-teach",
        text: "Teacher Attendance",
        exact: false,
        to: {
            name: "TeacherAttendance"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-account-group",
        text: "Record Management",
        exact: false,
        to: {
            name: "RecordManagement"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-account-group",
        text: "Groups",
        exact: false,
        to: {
            name: "Groups"
        }
    },
    {
        flag: 'admin',
        icon: "fas fa-file-word",
        text: "CatchUp",
        exact: false,
        to: {
            name: "CatchUps"
        }
    },
    {
        flag: 'admin',
        icon: "fas fa-file-word",
        text: "Work",
        exact: false,
        to: {
            name: "Works"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-account-cash-outline",
        text: "Accounts",
        exact: false,
        to: {
            name: "Accounts"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-clipboard-text",
        text: "Work Sheet",
        exact: false,
        to: {
            name: "WorkSheet"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-cog",
        text: "Settings",
        exact: false,
        to: {
            name: "Settings"
        }
    },
    {
        flag: 'admin',
        icon: "mdi-palette-swatch",
        text: "Reports",
        exact: false,
        to: {
            name: "Reports"
        }
    },
    // Tutor Modules
]

const StudentLinks = [
    {
        flag: 'student',
        icon: "mdi-school",
        text: "Student",
        exact: false,
        to: {
            name: "StudentProfileSP"
        }
    },
    {
        flag: 'student',
        icon: "mdi-teach",
        text: "Classes",
        exact: false,
        to: {
            name: "SPStudentClasses"
        }
    },
    // {
    //     icon: "fas fa-file-word",
    //     text: "Work",
    //     exact: false,
    //     to: {
    //         name: "StudentWork"
    //     }
    // },
    {
        flag: 'student',
        icon: "fas fa-file-word",
        text: "Catch up",
        exact: false,
        to: {
            name: "StudentCatchUp"
        }
    },
    {
        flag: 'student',
        icon: "mdi-account-cash-outline",
        text: "Accounts",
        exact: false,
        to: {
            name: "StudentAccounts"
        }
    },
    {
        flag: 'student',
        icon: "mdi-cloud-upload",
        text: "Upload Work",
        exact: false,
        to: {
            name: "Upload"
        }
    },
    {
        flag: 'student',
        icon: "mdi-clipboard-text",
        text: "Work Sheet",
        exact: false,
        to: {
            name: "StudentWorkSheet"
        }
    },
    {
        flag: 'student',
        icon: "mdi-form-select",
        text: "Admission Form",
        exact: false,
        to: {
            name: "AdmissionForm"
        }
    },

]

const TutorLinks = [

    {
        flag: 'tutor',
        icon: "fas fa-user",
        text: "Tutor",
        exact: true,
        to: {
            name: "TPTutorProfile"
        }
    },
    // {
    //     icon: "mdi-school",
    //     text: "Students",
    //     exact: false,
    //     to: {
    //         name: "TutorStudents"
    //     }
    // },
    {
        flag: 'tutor',
        icon: "mdi-teach",
        text: "Classes",
        exact: false,
        to: {
            name: "TutorClasses"
        }
    },
    {
        flag: 'tutor',
        icon: "mdi-account-cash-outline",
        text: "Accounts",
        exact: false,
        to: {
            name: "TutorAccounts"
        }
    },
    {
        flag: 'tutor',
        icon: "mdi-cloud-upload",
        text: "Uploaded Work",
        exact: false,
        to: {
            name: "TutorUploadedWork"
        }
    },
    {
        flag: 'tutor',
        icon: "mdi-clipboard-text",
        text: "Work Sheet",
        exact: false,
        to: {
            name: "TutorWorkSheet"
        }
    },
]

export default get_drawer_links